import React from 'react'
import { Drawer } from 'antd'
import { useDispatch } from 'react-redux'
import { rubricActions } from '../../../../../../store/slices/rubric.slice'
import CreateCategoryForm from './CreateCategoryForm'

const CreateCategoryDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(rubricActions.setShowCreateCategoryDrawer(false))

    return (
        <Drawer title='Create Category' autoFocus onClose={handleClose} open width={560} destroyOnClose zIndex={9000}>
            <CreateCategoryForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default CreateCategoryDrawer
